import type React from "react";
import { Box, Typography, Grid } from "@mui/material";
import rebecca from "./assets/rebecca.png";
import jared from "./assets/jared.png";
import max from "./assets/max.png";
import hit from "./assets/hit.png";
import foster from "./assets/foster.png";
import leon from "./assets/leon.png";

const TeamPage: React.FC = () => {
  const TeamAvatar = ({
    image,
    name,
    role,
  }: {
    image: string;
    name: string;
    role: string;
  }) => (
    <Box textAlign="center">
      <Box
        sx={{
          width: 160,
          height: 160,
          borderRadius: "50%",
          border: "1px solid #000",
          overflow: "hidden",
          mx: "auto",
          mb: 2,
        }}
      >
        <img
          src={image}
          crossOrigin="anonymous"
          alt={name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            backgroundColor: "#fff",
          }}
        />
      </Box>

      <Typography fontWeight={600}>{name}</Typography>
      <Typography variant="body2" color="text.secondary">
        {role}
      </Typography>
    </Box>
  );

  return (
    <Box
      id="team-page"
      sx={{
        height: "1056px",
        width: "816px",
        overflow: "hidden",
        transform: "scale(0.9)",
        transformOrigin: "top left",
      }}
    >
      {/* CO-FOUNDERS */}
      <Typography
        align="center"
        sx={{
          fontFamily: "Brittany, cursive",
          fontSize: 48,
          mb: 3,
        }}
      >
        Co-Founders
      </Typography>

      <Grid container spacing={6} justifyContent="center">
        <Grid>
          <TeamAvatar
            image={rebecca}
            name="Rebecca Bunga"
            role="Head of Sales"
          />
        </Grid>
        <Grid>
          <TeamAvatar
            image={jared}
            name="Jared Bunga"
            role="Head of Operations"
          />
        </Grid>
      </Grid>

      {/* CREW */}
      <Typography
        align="center"
        sx={{
          fontFamily: "Brittany, cursive",
          fontSize: 42,
        }}
      >
        Crew & Tech Team
      </Typography>

      <Grid
        container
        spacing={6}
        justifyContent="center"
        alignContent="center"
        sx={{ p: 3 }}
      >
        <Grid size={{ xs: 12, md: 3 }}>
          <TeamAvatar
            image={hit}
            name="Hurtman Talmud"
            role="Back End Developer"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TeamAvatar
            image={leon}
            name="Leon Manhimanzi"
            role="Front End Developer"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TeamAvatar
            image={max}
            name="Maxwell Manyanhaire"
            role="Head of User Interface"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TeamAvatar
            image={foster}
            name="Foster Jumbe"
            role="Pixel Pilot Producer"
          />
        </Grid>
      </Grid>

      <Typography align="center" mt={4} fontWeight={600}>
        + 50 Pixel Pilots
      </Typography>

      {/* STATS */}
      <Box mt={8} sx={{ ml: 3 }}>
        <Typography>➤ Streamed at over 150 Churches across Harare</Typography>
        <Typography mt={1}>
          ➤ 93% Success rate for all our Live Streams
        </Typography>
      </Box>

      {/* CONTACT */}
      <Typography
        align="center"
        sx={{
          fontFamily: "Brittany, cursive",
          fontSize: 56,
        }}
      >
        Contact Us
      </Typography>

      <Grid container spacing={4} textAlign="center">
        <Grid size={{ xs: 12, md: 3 }} borderRight={1}>
          <Typography fontWeight={700}>HARARE</Typography>
          <Typography variant="body2">ZIMBABWE</Typography>
          <Typography variant="body2" mt={1}>
            46B Mt Pleasant Drive
            <br />
            Mt Pleasant
          </Typography>
          <Typography variant="body2" mt={1}>
            +263 776 402 402
          </Typography>
          <Typography fontSize={28} mt={2}>
            🇿🇼
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }} borderRight={1}>
          <Typography fontWeight={700}>CAPE TOWN</Typography>
          <Typography variant="body2">SOUTH AFRICA</Typography>
          <Typography variant="body2" mt={1}>
            123 The Six Building
            <br />
            76 Sir Lowry Road
            <br />
            District 6, Zonnebloem
          </Typography>
          <Typography variant="body2" mt={1}>
            +27 72 860 7279
          </Typography>
          <Typography fontSize={28} mt={2}>
            🇿🇦
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }} borderRight={1}>
          <Typography fontWeight={700}>NAIROBI</Typography>
          <Typography variant="body2">KENYA</Typography>
          <Typography variant="body2" mt={1}>
            COMING SOON
          </Typography>
          <Typography variant="body2" mt={1}>
            www.muzukuru.com
          </Typography>
          <Typography fontSize={28} mt={2}>
            🇰🇪
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <Typography fontWeight={700}>LUSAKA</Typography>
          <Typography variant="body2">ZAMBIA</Typography>
          <Typography variant="body2" mt={1}>
            6 Green Lane
            <br />
            Kabulonga
          </Typography>
          <Typography variant="body2" mt={1}>
            +260 965 806 278
          </Typography>
          <Typography fontSize={28} mt={2}>
            🇿🇲
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TeamPage;
